import { Link } from 'react-router-dom';
import CtaBand from '../components/CtaBand';
import PageHero from '../components/PageHero';
import ProductCard from '../components/ProductCard';
import SectionHeader from '../components/SectionHeader';
import Seo from '../components/Seo';
import { EGRAHMANTREE_URL, NAV_PRODUCT_LINKS, PRODUCTS, SITE } from '../config/site';
import { PRODUCT_PAGES } from '../config/productPages';

const enterprise = PRODUCTS.filter((p) => p.pagePath);
const flagship = PRODUCTS.filter((p) => p.isFlagship);

export default function Products() {
  return (
    <>
      <Seo
        title="Products"
        description={`${SITE.shortName} — SutraMQ, SutraACS, MGOpen NMS, and eGrahmantree.`}
        path="/products"
      />

      <PageHero
        label="Products"
        title="Platforms we build, run, and support"
        tagline={SITE.domain}
        lead="Three enterprise platforms with dedicated product pages — plus eGrahmantree, our live consumer marketplace operating in Jaipur."
      />

      <section className="section product-section">
        <div className="container">
          <SectionHeader
            creative
            light
            label="Enterprise"
            title="IoT, telecom & network operations"
            description="Each product includes capabilities, architecture, and deployment guidance."
          />
          <div className="products-showcase-grid">
            {NAV_PRODUCT_LINKS.map((nav) => {
              const id = nav.path.split('/').pop();
              const page = PRODUCT_PAGES[id];
              const product = enterprise.find((p) => p.id === id);
              if (!product || !page) return null;
              return (
                <Link
                  key={nav.path}
                  to={nav.path}
                  className="products-showcase-card"
                  style={{ '--product-accent': page.accent }}
                >
                  <img src={page.heroImage} alt="" className="products-showcase-card__img" />
                  <div className="products-showcase-card__body">
                    <p className="products-showcase-card__eyebrow">{product.category}</p>
                    <h3>{page.name}</h3>
                    <p>{page.subheadline}</p>
                    <span className="products-showcase-card__cta">View product page →</span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section section--band product-section">
        <div className="container">
          <SectionHeader
            creative
            light
            label="Consumer"
            title="Live in market"
            description="Our flagship home-services platform — separate brand, same engineering standards."
          />
          <div className="products-grid products-grid--page">
            {flagship.map((product) => (
              <div key={product.id} id={product.id} className="product-anchor">
                <ProductCard product={product} variant="page" />
              </div>
            ))}
          </div>
          <p className="products-footer-note">
            Visit{' '}
            <a href={EGRAHMANTREE_URL} target="_blank" rel="noopener noreferrer">
              egrahmantree.com
            </a>{' '}
            for bookings. For enterprise products,{' '}
            <Link to="/demo">request a demo</Link>.
          </p>
        </div>
      </section>

      <section className="section product-section">
        <div className="container">
          <SectionHeader
            creative
            light
            align="center"
            label="Portfolio"
            title="One company, four product missions"
          />
          <div className="products-grid">
            {PRODUCTS.map((product) => (
              <ProductCard key={product.id} product={product} variant="grid" />
            ))}
          </div>
        </div>
      </section>

      <CtaBand
        creative
        title="Schedule a product demo"
        description="Walk through SutraMQ, SutraACS, or MGOpen NMS with our team — tailored to your scale and compliance requirements."
        primaryLabel="Request a demo"
        primaryHref="/demo"
        primaryExternal={false}
        secondaryLabel="Contact us"
        secondaryTo="/contact"
      />
    </>
  );
}
